import styles from './index.module.less';
import { useTranslation } from 'next-i18next';
import { useEffect, useMemo, useState } from 'react';
import GeneralContent from './GeneralContent';
import SubscriptionContent from './SubscriptionContent';
import RecordsContent from './BillingRecords';
import { getAuth, onAuthStateChanged, User } from 'firebase/auth';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import { useConfigProvider } from '@/context/ConfigProvider';
import { getUserInfo } from '@/lib/service';
import { UserInfo } from '@/types/home';
import ResultsContent from './ResultsContent';

export default function SettingsContent() {
  const { t } = useTranslation();
  const router = useRouter();
  const [currentUser, setCurrentUser] = useState<User>();
  const [userInfo, setUserInfo] = useState<UserInfo>();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const { isBlogWeb } = useConfigProvider();

  const [currentType, setCurrentType] = useState<string>('1');

  const navList = useMemo(() => {
    return [
      {
        title: t('Account Details'),
        type: '1',
      },
      {
        title: t('Manage Subscription'),
        type: '2',
      },
      {
        title: t('Payment History'),
        type: '3',
      },
      {
        title: t('Results'),
        type: '4',
      },
    ];
  }, []);

  // 获取用户信息
  const getUserInfoAsync = () => {
    getUserInfo()
      .then((res) => {
        console.log(res.data);
        setUserInfo(res.data);
      })
      .catch((e) => {});
  };

  useEffect(() => {
    if (isBlogWeb) {
      return () => {
        router.push('/instagram-tracking-blog');
      };
    } else {
      const auth = getAuth();
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        if (user) {
          setCurrentUser(user);
          getUserInfoAsync();
        } else {
          setCurrentUser(null);
          router.push('/');
        }
      });

      return () => {
        unsubscribe();
      };
    }
  }, []);

  const listMenu = useMemo(() => {
    return (
      <nav className={styles.nav}>
        {navList?.map((item) => (
          <span
            key={item?.type}
            className={classNames([styles.navSpan, currentType === item?.type && styles.navSpanActive])}
            onClick={() => {
              setCurrentType(item?.type);
              setDrawerOpen(false);
            }}
          >
            {item?.title}
          </span>
        ))}
      </nav>
    );
  }, [navList, currentType]);

  return (
    <div style={{ background: '#FFF', minHeight: '100vh' }}>
      <div className={styles.topContent}>
        <div className={styles.titleContent}>
          <h1>{t('Settings')}</h1>

          <div className={styles.phoneSidebar}>{listMenu}</div>
        </div>
      </div>

      <div className={styles.container}>
        {/* Sidebar */}
        <div className={styles.sidebar}>{listMenu}</div>

        {/* Main Content */}
        <div className={styles.content}>
          <div className={styles.card}>
            {currentType === '1' && (
              <GeneralContent
                currentUser={currentUser}
                userInfo={userInfo}
                updateUserInfo={(info?: any) => {
                  if (info) {
                    setUserInfo({ ...userInfo, ...info });
                  }
                }}
              />
            )}
            {currentType === '2' && <SubscriptionContent />}
            {currentType === '3' && <RecordsContent />}
            {currentType === '4' && <ResultsContent />}
          </div>
        </div>
      </div>
    </div>
  );
}
